// src/icons/svgs/clear-text-style.svg
import * as React from "react";
import { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
var SvgClearTextStyle = (props, ref) => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 28, height: 28, fill: "none", viewBox: "0 0 28 28", ref, ...props, children: /* @__PURE__ */ jsx("path", { fill: "#343A40", fillRule: "evenodd", d: "M3.74 23.16a.778.778 0 0 0 1.1 1.1l8.382-8.382v6.677H10.5a.778.778 0 0 0 0 1.556h7a.778.778 0 0 0 0-1.556h-2.722v-8.233l7.777-7.777v1.622a.778.778 0 1 0 1.556 0V4.989l.95-.95a.778.778 0 1 0-1.1-1.1l-.95.95H4.667a.78.78 0 0 0-.778.778v3.5a.778.778 0 0 0 1.555 0V5.444h7.778v8.234zm11.038-11.038 6.678-6.678h-6.678z", clipRule: "evenodd" }) });
var ForwardRef = forwardRef(SvgClearTextStyle);
var clear_text_style_default = ForwardRef;
export {
  clear_text_style_default as ClearTextStyle
};
